module.exports = __webpack_public_path__ + "img/qg3_01.538708df.png";